import type { ChequeDirection, ChequeStatus } from '../../lib/types/finance.js';

/** Mirrors `assertValidTransition` in packages/modules/accounting/src/subledger/cheque.ts. */
const ALLOWED: Record<ChequeDirection, Partial<Record<ChequeStatus, readonly ChequeStatus[]>>> = {
  inward: {
    in_safe: ['in_collection', 'cleared', 'returned'],
    in_collection: ['cleared', 'bounced'],
    bounced: ['in_collection', 'returned'],
  },
  outward: {
    issued: ['delivered', 'voided'],
    delivered: ['cleared', 'bounced'],
    bounced: ['cleared', 'voided'],
  },
};

export function allowedChequeTransitions(
  direction: ChequeDirection,
  status: ChequeStatus,
): readonly ChequeStatus[] {
  return ALLOWED[direction][status] ?? [];
}

export const TRANSITION_BUTTON_LABEL: Partial<Record<ChequeStatus, string>> = {
  in_collection: 'واگذاری به بانک',
  cleared: 'ثبت وصول',
  bounced: 'ثبت برگشت',
  returned: 'عودت چک',
  delivered: 'تحویل به ذینفع',
  voided: 'ابطال چک',
};

/** Transitions that post a journal and therefore need a counter GL account. */
export function transitionNeedsGlAccount(
  direction: ChequeDirection,
  toStatus: ChequeStatus,
): boolean {
  if (direction === 'inward') {
    return toStatus === 'in_collection' || toStatus === 'cleared' || toStatus === 'bounced';
  }
  return toStatus === 'cleared';
}

export function isValidSayadId(value: string): boolean {
  return /^\d{16}$/.test(value);
}

export function isPositiveRial(value: string): boolean {
  return /^[1-9]\d*$/.test(value);
}

/** Persian/Arabic digits → ASCII so pasted or scanned values validate. */
export function normalizeDigits(value: string): string {
  return value
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0))
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660));
}

export function pickDefaultPeriod<
  P extends { fiscalPeriodId: string; fiscalYearId: string; postingState: string },
>(periods: readonly P[]): P | undefined {
  return periods.find((p) => p.postingState === 'open') ?? periods[0];
}
